import {
  Home,
  Package,
  ArrowRightLeft,
  PieChart,
  TrendingUp,
  Coins,
  Calculator,
  Target,
} from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { useT } from "@/lib/translation";
import {
  SidebarNav,
  type SidebarNavItem,
} from "@/components/shared/SidebarNav";
import { useUserSettings } from "@/features/settings/hooks/useUserSettings";
import { getMe } from "@/api/client";

export const Navigation = () => {
  const t = useT();
  const { data: me } = useQuery({ queryKey: ["me"], queryFn: getMe });
  const { userSettings } = useUserSettings(!!me);

  const navItems: SidebarNavItem[] = [
    {
      to: "/portfolio/dashboard",
      end: true,
      icon: Home,
      label: t("nav:items.dashboard"),
    },
    {
      to: "/portfolio/portfolios",
      end: true,
      icon: Package,
      label: t("nav:items.portfolios"),
    },
    {
      to: "/portfolio/transactions",
      icon: ArrowRightLeft,
      label: t("nav:items.transactions"),
      isActive: (pathname, routerIsActive) =>
        routerIsActive ||
        !!pathname.match(/^\/portfolio\/portfolios\/\d+\/transactions$/),
    },
    {
      to: "/portfolio/holdings",
      icon: PieChart,
      label: t("nav:items.holdings"),
      isActive: (pathname, routerIsActive) =>
        routerIsActive || !!pathname.match(/^\/portfolio\/portfolios\/\d+$/),
    },
    {
      to: "/portfolio/performance",
      icon: TrendingUp,
      label: t("nav:items.performance"),
    },
    {
      to: "/portfolio/dividends",
      icon: Coins,
      label: t("nav:items.dividends"),
    },
    {
      to: "/portfolio/goals",
      icon: Target,
      label: t("nav:items.goals"),
    },
    // Supported for the user's country. Gated by plan on the page itself, not hidden here.
    ...(userSettings?.is_tax_calculator_supported
      ? [
          {
            to: "/portfolio/taxes",
            icon: Calculator,
            label: t("nav:items.taxCalculatorNav"),
          } as SidebarNavItem,
        ]
      : []),
  ];

  return <SidebarNav navItems={navItems} roadmapPath="/portfolio/roadmap" />;
};
